import type { FC, ReactElement } from "react"

import isString from "lodash-es/isString"
import isUndefined from "lodash-es/isUndefined"

import { Link } from "@/3514/components/shared/link/link.component"
import { Typography } from "@/3514/components/shared/typography/typography.component"
import {
    ETypographyColor,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight
} from "@/3514/components/shared/typography/typography.types"
import { type TProductTypeQuery, useProductTypeQuery } from "@/3514/queries"
import { CARE_TEAM_EMAIL } from "@/constants"
import { type IUseTranslation, type TTranslationKeys, useTranslation } from "@/hooks"

const classes = { hint: "flex gap-x-[5px] items-center self-center" }

type _TProps = {
    hintTranslationKey?: keyof TTranslationKeys
    linkTranslationKey?: keyof TTranslationKeys
    linkPath?: string
    linkColor?: ETypographyColor
}

const HelpHint: FC<_TProps> = ({
    hintTranslationKey = "common.helpHint.question.needHelp",
    linkTranslationKey = "common.helpHint.action",
    linkPath = undefined,
    linkColor = ETypographyColor.Accent
}: _TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    const { data: productType }: TProductTypeQuery = useProductTypeQuery()

    return (
        <div className={classes.hint}>
            <Typography
                text={t(hintTranslationKey)}
                color={ETypographyColor.Dark}
                tag={ETypographyTag.Paragraph}
                size={ETypographySize.Small}
            />
            <Link
                to={
                    isUndefined(linkPath)
                        ? isString(productType?.supportEmail)
                            ? `mailto:${productType?.supportEmail}`
                            : CARE_TEAM_EMAIL
                        : linkPath
                }
                textSize={ETypographySize.Small}
                textWeight={ETypographyWeight.Default}
                textColor={linkColor}
            >
                {t(linkTranslationKey)}
            </Link>
        </div>
    )
}

HelpHint.displayName = "HelpHint"

export { HelpHint }
